import script from "./StreamPageCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamPageCreator.vue?vue&type=script&setup=true&lang=js"

import "./StreamPageCreator.vue?vue&type=style&index=0&id=affc7734&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-affc7734"]])

export default __exports__